import { ReactElement, useMemo } from 'react';

import LoadingFallback from '~components/LoadingFallback';

import { DashboardVariantV2CarrierContentCollectTabTrackingContainer } from './styles';

import DashboardVariantV2CarrierContentCollectTrackingProvider, {
  useDashboardVariantV2CarrierContentCollectTrackingContext,
} from './Context';
import DashboardVariantV2CarrierContentCollectTabTrackingSelection from './Selection';
import DashboardVariantV2CarrierContentCollectTabTrackingMap from './Map';

const DashboardVariantV2CarrierContentCollectTabTracking = (): ReactElement => {
  const {
    tabsData: { isFirstRequest: isFirstRequestTabData },
    mapData: { isFirstRequest: isFirstRequestMapData },
  } = useDashboardVariantV2CarrierContentCollectTrackingContext();

  const initialLoading = useMemo(
    () => isFirstRequestTabData || isFirstRequestMapData,
    [isFirstRequestTabData, isFirstRequestMapData],
  );

  return (
    <DashboardVariantV2CarrierContentCollectTabTrackingContainer>
      {initialLoading && <LoadingFallback />}

      {!initialLoading && (
        <>
          <DashboardVariantV2CarrierContentCollectTabTrackingSelection />

          <DashboardVariantV2CarrierContentCollectTabTrackingMap />
        </>
      )}
    </DashboardVariantV2CarrierContentCollectTabTrackingContainer>
  );
};

const DashboardVariantV2CarrierContentCollectTabTrackingWrapper =
  (): ReactElement => (
    <DashboardVariantV2CarrierContentCollectTrackingProvider>
      <DashboardVariantV2CarrierContentCollectTabTracking />
    </DashboardVariantV2CarrierContentCollectTrackingProvider>
  );

export default DashboardVariantV2CarrierContentCollectTabTrackingWrapper;
